import LocalDate from '@booking-services/localDate'
const mapToLocalDate = date => date ? new LocalDate(date) : date

export default function dateWindowEffective ({dateWindow, date, toExclusive}) {
  if (!dateWindow || !date || dateWindow.length === 0) {
    return true
  }
  if (Array.isArray(dateWindow)) {
    return dateWindow.some(dateWindowItem => dateWindowEffective({
      dateWindow: dateWindowItem,
      date,
      toExclusive,
    }))
  }

  const from = mapToLocalDate(dateWindow.from)
  const to = mapToLocalDate(dateWindow.to)

  return (
    (from ? from <= date : true) &&
    (to ? date < to.addDays(toExclusive ? 0 : 1) : true)
  )
}
